import { render, staticRenderFns } from "./setAreaFilter.vue?vue&type=template&id=23526068&"
import script from "./setAreaFilter.vue?vue&type=script&lang=js&"
export * from "./setAreaFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports